import type React from "react"
import AuthLayout from "../../components/auth/AuthLayout"
import ForgotPasswordForm from "../../components/auth/ForgotPasswordForm"

const ForgotPasswordPage: React.FC = () => {
  return (
    <AuthLayout title="Reset Password" subtitle="We'll help you get back into your account" allowScroll={false}>
      <ForgotPasswordForm />
    </AuthLayout>
  )
}

export default ForgotPasswordPage
